import React, { useEffect, useState } from 'react'
import GetFormattedDate from '../Movie/getFormateddateforlistmovies'
import AwsConfig from '../../Config/AwsConfig'
import AutoSuggestions from '../../Services/Queries/AutoSuggestions'
// import PosterCdnCheck from '../CreateListmoviespersons/PosterCdnCheck'
import MovieImagePresignedUrl from '../../Services/Queries/Movieimagepresignedurl'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import ManualPNTittleImage from './ManualPNTittleImage'
import SendPNManually from '../../Services/Mutations/SendPNManually'
import { toast } from 'react-toastify'
import { ToastStyle } from '../Data/MovieStaticData'

const SendPNManuallyInputForm = () => {
  const [formData, setFormData] = useState({
    titleEn: '',
    titleTe: '',
    descriptionEn: '',
    descriptionTe: '',
    posterUrl: '',
    contentType: '',
    personId: '',
    movieId: '',
  })

  const [searchValue, setSearchValue] = useState('')
  const [searchResults, setSearchResults] = useState({ persons: [], movies: [] })
  // const [selectedResult, setSelectedResult] = useState(null)
  const [selectedType, setSelectedType] = useState('')
  const [PnDisable, setPnDisable] = useState('')

  const handleInputChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const selectedResultChange = (selected, type) => {
    // setSelectedResult(selected)
    setPnDisable(false)
    setSearchResults({ persons: [], movies: [] })
    if (type === 'Person') {
      setFormData({
        titleEn: selected.name_En,
        titleTe: selected.name_Te,
        descriptionEn: selected.about_En,
        descriptionTe: selected.about_Te,
        posterUrl: selected.posterURL,
        contentType: selectedType,
        personId: selected.PK,
      })
      setSearchValue(selected.PK)
    } else {
      setFormData({
        titleEn: selected.title_En,
        titleTe: selected.title_Te,
        descriptionEn: selected.about_En,
        descriptionTe: selected.about_Te,
        posterUrl: selected.posterURL,
        contentType: selectedType,
        movieId: selected.PK,
      })
      setSearchValue(selected.PK)
    }
  }

  const uploadSelectedImage = async (field, urlImage) => {
    try {
      const randomId = await uuidv4()
      const moviePath = AwsConfig.pnImagePath
      const key = `${moviePath}${randomId}.jpeg`

      const params = {
        key,
        mimeType: 'image/jpeg',
      }

      const preSignedURLObject = await getPreSignedURL(params)
      const { fields, url: signedURL } = preSignedURLObject.data

      const formDataPoster = new FormData()
      Object.entries(fields).forEach(([key, value]) => {
        formDataPoster.append(key, value)
      })
      formDataPoster.append('file', urlImage)

      await uploadToS3(signedURL, formDataPoster)
      setFormData({ ...formData, [field]: key })
    } catch (err) {
      console.warn(err, 'err')
    }
  }

  const getPreSignedURL = async params => {
    const preSignedURLObject = await MovieImagePresignedUrl(params)
    return JSON.parse(preSignedURLObject.signedObject)
  }

  const uploadToS3 = async (signedURL, formData) => {
    await axios({
      method: 'post',
      url: signedURL,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  const handleImageUpload = (field, file) => {
    //
    uploadSelectedImage(field, file)
  }

  //
  const handleSearchChange = async event => {
    const { value } = event.target
    setSearchValue(value)
    if (!value) {
      setFormData({
        titleEn: '',
        titleTe: '',
        descriptionEn: '',
        descriptionTe: '',
        posterUrl: '',
        contentType: '',
        personId: '',
        movieId: '',
      })
      setPnDisable(false)
    }

    try {
      if (value.length >= 3) {
        const input = {
          search: value,
          type: selectedType === 'movies' ? 'movie' : selectedType,
          limit: 100,
          from: 0,
          status: 'published',
        }
        const { movieHits, personHits } = await AutoSuggestions(input)
        setSearchResults({
          persons: personHits || [],
          movies: movieHits || [],
        })
      } else {
        setSearchResults({ persons: [], movies: [] })
      }
    } catch (error) {
      console.error('Error fetching data:', error)
      setSearchResults({ persons: [], movies: [] })
    }
  }

  const handleSelectResult = event => setSelectedType(event.target.value)

  const renderHits = (results, type) =>
    results.length >= 1 && (
      <div
        className='searchfield'
        style={{
          height: results.length >= 1 ? '60vh' : '',
          width: '100%',
          position: 'relative',
          zIndex: '1',
        }}
      >
        <label>{type === 'Movie' ? 'Movies/Webseries' : 'Persons'}</label>
        <div>
          {results.map((result, index) => {
            let posterUrl = result.posterURL
            const releaseDate = GetFormattedDate(parseInt(result.movieReleasedDate || '0', 10))
            if (result.posterURL === 'none' || result.posterURL === '') {
              posterUrl =
                AwsConfig.movieCdnUrl + AwsConfig.avatharPath + AwsConfig.personStaticImage
            } else if (result.posterURL && !result.posterURL.includes(AwsConfig.movieCdnUrl)) {
              posterUrl = AwsConfig.movieCdnUrl + result.posterURL
            }

            const displayText = type === 'Movie' ? result.title_En : result.name_En
            const additionalInfo = type === 'Movie' ? result.wikipediaLink : result.personWikiURL

            return (
              <div
                key={index}
                style={{ width: '100%', marginRight: 'auto', boxSizing: 'unset', height: '4rem' }}
                onClick={() => selectedResultChange(result, type)}
              >
                <ul className='list-group list-group-flush'>
                  <li className='list-group-item' style={{ marginRight: 'auto', width: '100%' }}>
                    <div className='media d-flex justify-content-center align-items-center'>
                      {posterUrl && (
                        <img
                          style={{ width: '2.5rem', height: '2.5rem', marginRight: 'auto' }}
                          className='mr-3 align-self-center'
                          src={posterUrl}
                          alt='Poster'
                        />
                      )}
                      <div
                        className='media-body align-self-center'
                        style={{ display: 'flex', flexDirection: 'column', fontSize: '10px' }}
                      >
                        <span>
                          <b>{`${type} Name:`}</b> {displayText}
                        </span>
                        {releaseDate && (
                          <span>
                            <b>Release Date:</b>
                            {releaseDate.toString()}
                          </span>
                        )}
                        {result.roles && (
                          <span
                            style={{ whiteSpace: 'pre-wrap', width: '30%' }}
                          >{`(${result.roles.toString()})`}</span>
                        )}
                        <span>{additionalInfo}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            )
          })}
        </div>
      </div>
    )

  const handleSubmit = async () => {
    setPnDisable(true)
    const input = {
      title_En: formData.titleEn,
      title_Te: formData.titleTe,
      description_En: formData.descriptionEn,
      description_Te: formData.descriptionTe,
      posterURL: formData.posterUrl,
      contentType: selectedType,
    }

    if (selectedType === 'person') {
      input.personID = formData.personId
    } else {
      input.movieID = formData.movieId
    }

    const sendPn = await SendPNManually(input)
    if (sendPn.statusCode === '200') {
      toast.success(sendPn.statusMessage, ToastStyle)
    }
  }

  useEffect(() => {
    if (selectedType) {
      // setSelectedResult(null)
      setFormData({
        titleEn: '',
        titleTe: '',
        descriptionEn: '',
        descriptionTe: '',
        posterUrl: '',
        contentType: '',
        personId: '',
        movieId: '',
      })
      setSearchValue('')
      setPnDisable(false)
    }
  }, [selectedType])
  return (
    // <form onSubmit={handleSubmit}>
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <label style={{ textAlign: 'center' }}>Manual PN</label>
      </div>
      <div>
        <label>Content Type:</label>
        <select
          id='videoPlatform'
          name='videoPlatform'
          className='form-control'
          //   value={previewVideo.videoPlatform}
          onChange={handleSelectResult}
          style={{ width: '45%' }}
        >
          <option value=''></option>
          <option value='movies'>Movie</option>
          <option value='person'>Person</option>
          <option value='webseries'>Webseries</option>
        </select>
      </div>
      {selectedType === 'person' && (
        <div>
          <label>Person ID:</label>
          <input
            className='form-control'
            type='text'
            name='personId'
            value={searchValue}
            onChange={handleSearchChange}
            placeholder='Search for persons...'
          />
          {renderHits(searchResults.persons, 'Person')}
        </div>
      )}
      {(selectedType === 'movies' || selectedType === 'webseries') && (
        <div>
          <label>Movie ID:</label>
          <input
            className='form-control'
            type='text'
            name='movieId'
            value={searchValue}
            onChange={handleSearchChange}
            placeholder='Search for movies...'
          />
          {renderHits(searchResults.movies, 'Movie')}
        </div>
      )}
      {selectedType && (formData.personId || formData.movieId) && (
        <ManualPNTittleImage
          formData={formData}
          handleInputChange={handleInputChange}
          handleImageUpload={handleImageUpload}
          handleSubmit={handleSubmit}
          PnDisable={PnDisable}
        />
      )}
    </div>
  )
}

export default SendPNManuallyInputForm
